import React, { useEffect, useState, useRef } from 'react';
import { Testimonial } from './types';
import { TestimonialCard } from './TestimonialCard';
interface ScrollingColumnProps {
  testimonials: Testimonial[];
  direction?: 'up' | 'down';
  speed?: number;
  'data-id'?: string;
}
export function ScrollingColumn({
  testimonials,
  direction = 'up',
  speed = 15,
  'data-id': dataId
}: ScrollingColumnProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) return;
    let animationFrameId: number;
    let currentPosition = direction === 'up' ? 0 : -scrollElement.scrollHeight / 2;
    const animate = () => {
      if (!scrollElement || isPaused) {
        animationFrameId = requestAnimationFrame(animate);
        return;
      }
      const scrollHeight = scrollElement.scrollHeight / 2;
      const delta = speed / 60;
      if (direction === 'up') {
        currentPosition -= delta;
        if (currentPosition <= -scrollHeight) {
          currentPosition = 0;
        }
      } else {
        currentPosition += delta;
        if (currentPosition >= 0) {
          currentPosition = -scrollHeight;
        }
      }
      scrollElement.style.transform = `translateY(${currentPosition}px)`;
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [direction, speed, isPaused]);
  // Duplicate testimonials for seamless loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];
  return <div className="relative w-[320px] h-[600px] overflow-hidden" style={{
    maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)'
  }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-1680">
      <div ref={scrollRef} className="flex flex-col gap-6" style={{
      willChange: 'transform'
    }} data-id="element-1681">
        {duplicatedTestimonials.map((testimonial, index) => <TestimonialCard key={`${testimonial.id}-${index}`} testimonial={testimonial} data-id="element-1682" />)}
      </div>
    </div>;
}